import { Component, Input } from '@angular/core';
import { HeadlineCategory, UNCLASSIFIED_CATEGORY, getHeadlineCategory } from '../../constants/headline-categories';

/**
 * Renders a small neutral pill for each of a headline's categories, trailing the
 * headline title. Empty inputs render nothing at all — the host is inline and
 * unpadded, so an unclassified row costs no horizontal space.
 */
@Component({
    selector: 'rms-headline-category-pills',
    templateUrl: './headline-category-pills.component.html',
    styleUrls: ['./headline-category-pills.component.scss'],
    standalone: false
})
export class HeadlineCategoryPillsComponent {
  @Input() categories: Array<string> = [];
  /**
   * Draw the abbreviated `shortLabel` instead of the full `label`. Off by default so the
   * full-width Headlines page is unaffected; the company page's Headlines tab opts in
   * because its column cannot hold the long forms.
   */
  @Input() short = false;

  /**
   * The categories to draw as pills, resolved through the catalog. The unclassified
   * sentinel is excluded defensively — the classifier represents "no category" as an
   * empty list, and a row that reaches the feed unclassified should carry no pill.
   */
  public get visiblePills(): Array<HeadlineCategory> {
    return (this.categories || [])
      .filter(name => name !== UNCLASSIFIED_CATEGORY)
      .map(name => getHeadlineCategory(name));
  }
}
